import { graphql, http, HttpResponse } from 'msw';
import { MOCK_CLIENT_ID } from '../../../../mocks';
const stitchfix = graphql.link(process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT || '');

// Mock for getClientInfo query
export const getClientInfo = stitchfix.query('getClientInfo', () => {
  return HttpResponse.json({
    data: {
      client: {
        __typename: 'Client' as const,
        id: MOCK_CLIENT_ID,
        isAuthenticatedClient: true,
        capabilities: {
          __typename: 'ClientCapabilities' as const,
          canShop: true,
          canScheduleFix: true
        }
      }
    }
  });
});

// Mock for getClientSelfie query
export const getClientSelfie = stitchfix.query('getClientSelfie', () => {
  return HttpResponse.json({
    data: {
      client: {
        businessLine: 'WOMENS',
        __typename: 'Client' as const,
        id: MOCK_CLIENT_ID,
        selfieImageUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png'
      }
    }
  });
});
export const getClientSelfieWithNoImage = stitchfix.query('getClientSelfie', () => {
  return HttpResponse.json({
    data: {
      client: {
        businessLine: 'WOMENS',
        __typename: 'Client' as const,
        id: MOCK_CLIENT_ID,
        selfieImageUrl: ''
      }
    }
  });
});
export const getClientFullBodyWithNoImage = stitchfix.query('getClientFullBody', () => {
  return HttpResponse.json({
    data: {
      client: {
        __typename: 'Client' as const,
        businessLine: 'WOMENS',
        id: MOCK_CLIENT_ID,
        photoFullBody: null
      }
    }
  });
});

// Mock for getClientFullBody query
export const getClientFullBody = stitchfix.query('getClientFullBody', () => {
  return HttpResponse.json({
    data: {
      client: {
        __typename: 'Client' as const,
        businessLine: 'WOMENS',
        id: MOCK_CLIENT_ID,
        photoFullBody: {
          __typename: 'ClientPhoto' as const,
          id: 'mock-full-body-photo-id',
          image: {
            __typename: 'Image' as const,
            baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/',
            mediaPath: 'v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
            altText: 'Mock full body photo',
            width: 800,
            height: 600
          }
        }
      }
    }
  });
});

// Mock for clientSelfieUpdate mutation
export const clientSelfieUpdate = stitchfix.mutation('clientSelfieUpdate', () => {
  return HttpResponse.json({
    data: {
      clientSelfieUpdate: {
        __typename: 'ClientSelfieUpdatePayload' as const,
        result: {
          __typename: 'Client' as const,
          businessLine: 'WOMENS',
          id: MOCK_CLIENT_ID,
          selfieImageUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png'
        }
      }
    }
  });
});

// Mock for clientPhotoFullBodyCreate mutation
export const clientPhotoFullBodyCreate = stitchfix.mutation('clientPhotoFullBodyCreate', () => {
  return HttpResponse.json({
    data: {
      clientPhotoFullBodyCreate: {
        __typename: 'ClientPhotoFullBodyCreatePayload' as const,
        result: {
          __typename: 'ClientPhotoFullBodyCreateSuccess' as const,
          clientPhoto: {
            __typename: 'ClientPhoto' as const,
            id: 'mock-full-body-photo-id',
            image: {
              __typename: 'Image' as const,
              baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/',
              mediaPath: 'v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
              altText: 'Mock full body photo',
              width: 800,
              height: 600
            }
          }
        }
      }
    }
  });
});

// Mock for visionOnboardingComplete mutation
export const visionOnboardingComplete = stitchfix.mutation('visionOnboardingComplete', () => {
  return HttpResponse.json({
    data: {
      visionOnboardingComplete: {
        __typename: 'VisionOnboardingCompletePayload' as const,
        result: {
          __typename: 'VisionOnboardingCompleteSuccess' as const,
          isOptedInToRecurringLooks: true
        }
      }
    }
  });
});

// Mock for Cloudinary upload
export const cloudinaryUpload = http.post('https://api.cloudinary.com/v1_1/stitch-fix/image/upload', () => {
  return HttpResponse.json({
    public_id: 'client_selfies/btxrh3ax0fvjlknvvzzl',
    secure_url: 'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
    url: 'http://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
    format: 'png',
    width: 800,
    height: 600
  });
});
export const clientSelfieUpdateError = stitchfix.mutation('clientSelfieUpdate', () => {
  return HttpResponse.json({
    data: {
      clientSelfieUpdate: {
        __typename: 'ClientSelfieUpdatePayload' as const,
        result: {
          __typename: 'ClientSelfieUpdateError' as const,
          code: 'INVALID_BUSINESS_LINE' as const,
          message: 'Mock error message for clientSelfieUpdate'
        }
      }
    }
  });
});
export const clientPhotoFullBodyCreateError = stitchfix.mutation('clientPhotoFullBodyCreate', () => {
  return HttpResponse.json({
    data: {
      clientPhotoFullBodyCreate: {
        __typename: 'ClientPhotoFullBodyCreatePayload' as const,
        result: {
          __typename: 'ClientPhotoFullBodyCreateError' as const,
          code: 'INVALID_BUSINESS_LINE' as const,
          message: 'Mock error message for clientPhotoFullBodyCreate'
        }
      }
    }
  });
});